import React from 'react';
import { LocationContainerProps } from '.';
import FetchComponent from '../../../components/behavior/FetchComponent';
import { Spinner } from '../../../components/Spinner';

const AsyncLocationContainer = (props: LocationContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('.' /* webpackChunkName: "location-container" */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

export default AsyncLocationContainer;
